import { ApplicationFormTemplate } from '../../../../../../../../entities/v1/applicant_tracking/ApplicationFormTemplate';
import { Question } from '../../../../../../../../entities/v1/survey_engine/Question';
import { SelectOption } from '../../../../../../../../components/Select';
import { Option } from '../../../../../../../../entities/v1/survey_engine/Option';

export interface QuestionSelectOption extends SelectOption {
  data?: {
    fieldType: string;
    options: Option[];
  };
}

export function getAllQuestionsFromTemplates(
  templates: ApplicationFormTemplate[],
): Question[] {
  return templates.reduce((acc: Question[], template) => {
    const questions =
      template?.surveyTemplate?.sections?.reduce(
        (sectionAcc: Question[], section) => [
          ...sectionAcc,
          ...(section?.questions || []),
        ],
        [],
      ) || [];
    return [...acc, ...questions];
  }, []);
}

export function removeDuplicates(questions: Question[]): Question[] {
  const uniqueQuestions = new Map<string, Question>();

  // Keep only one question per title (the first one encountered)
  questions.forEach((question) => {
    if (question?.title && !uniqueQuestions.has(question.title)) {
      uniqueQuestions.set(question.title, question);
    }
  });

  return Array.from(uniqueQuestions.values());
}

export function mapQuestionsToSelectOptions(
  questions: Question[],
  selectedValue?: string,
): QuestionSelectOption[] {
  const uniqueQuestions = removeDuplicates(questions);

  return uniqueQuestions
    .filter(
      (question) =>
        question?.fieldType !== null &&
        question?.title &&
        question.isCustomQuestion,
    )
    .map((question) => ({
      value: question.title,
      label: question.title,
      selected: selectedValue === question.title,
      data: {
        fieldType: question.fieldType,
        options: question.options || [],
      },
    }));
}

export function findQuestionById(
  templates: ApplicationFormTemplate[],
  questionId: string,
): Question | undefined {
  const allQuestions = getAllQuestionsFromTemplates(templates);
  return allQuestions.find(
    (q) => q.id.toString() === questionId && q.isCustomQuestion,
  );
}

export function findQuestionByTitle(
  templates: ApplicationFormTemplate[],
  questionTitle: string,
): Question | undefined {
  const allQuestions = getAllQuestionsFromTemplates(templates);
  // Find the first question with a matching title
  return allQuestions.find(
    (q) => q.title === questionTitle && q.isCustomQuestion,
  );
}
